import { gql } from "lib/apolloClient";

export const getCasExternalInviteLinkQuery = gql`
  query getCASExternalSupervisorInviteLink($id: ID!) {
    node(id: $id, type: STAFF) {
      id
      ... on Staff {
        id
        casExternalSupervisorInviteUrl
      }
    }
  }
`;
